// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jdxX","content":"styles_content__33WQL"};